import axiosLib from 'axios';
import token from './token';

let axios = axiosLib;
const api = (url, method, data, goTo, actionTypes) => (dispatch, mockAxios) => {
  const { responder, loading, error } = actionTypes;

  if (mockAxios.get) axios = mockAxios;

  dispatch({
    payload: url,
    type: loading,
  });
  axios.defaults.headers.common.Authorization = `Bearer ${token.get()}`;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  return axios[method.toLowerCase()](`${process.env.REACT_APP_BASE_URL}/${url}`, data)
    .then(res => {
      // eslint-disable-next-line no-console
      console.log('RESPONSE:', res);
      dispatch({
        payload: url,
        type: loading,
      });
      dispatch({
        payload: res.data,
        type: responder,
      });
      if (goTo) goTo();

      return true;
    }).catch(e => {
      dispatch({
        payload: url,
        type: loading,
      });
      dispatch({
        errorObj: e,
        payload: e.response && e.response.data.message,
        type: error,
      });

      return false;
    });
};

export default api;
